import React from "react";
import { FiCode, FiShield, FiGlobe } from "react-icons/fi";
import SectionHeader from "./SectionHeader";
import useRevealOnScroll from "../hooks/useRevealOnScroll";
import { useLanguage } from "../context/LanguageContext";
import translations from "../i18n/translations";

function Highlights() {
  const { elementRef, isVisible } = useRevealOnScroll();
  const { language } = useLanguage();
  const t = translations[language];

  const iconComponents = [
    <FiCode className="h-6 w-6 text-coding-color" />,
    <FiShield className="h-6 w-6 text-coding-color" />,
    <FiGlobe className="h-6 w-6 text-coding-color" />,
  ];

  return (
    <section
      ref={elementRef}
      className={`px-6 py-16 md:px-16 lg:px-28 ${
        isVisible ? "animate-fade-in-up" : ""
      }`}
    >
      <div className="mx-auto max-w-6xl">
        <SectionHeader
          eyebrow={t.highlights.eyebrow}
          title={t.highlights.title}
          align="left"
        />
        <div className="mt-10 grid gap-6 md:grid-cols-3">
          {t.highlights.items.map((item, index) => (
            <article
              key={item.title}
              className={`flex flex-col gap-3 rounded-xl bg-gray-900/80 p-5 shadow-lg ring-1 ring-gray-800 transition duration-500 ${
                isVisible ? "animate-fade-in-up" : ""
              } hover:-translate-y-2`}
              style={{ animationDelay: `${index * 120}ms` }}
            >
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gray-800">
                {iconComponents[index]}
              </div>
              <h3 className="text-lg font-semibold text-white">{item.title}</h3>
              <p className="text-sm text-gray-300">{item.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Highlights;
